import { PlusIcon } from "djinn-components";
import React from "react";
import { Controller } from "react-hook-form";
import Form from "../../Form";
import FormFieldErrors from "../../Form/FormFieldErrors";
import FAQEditField from "../../Inputs/FAQEditField";
import { toast } from "react-toastify";
import { useSiteState } from "../../../utils/useSiteState";
import { FAQType } from "../../../types/api";

interface FAQsEditFormProps {}

const FAQsEditForm: React.FC<FAQsEditFormProps> = () => {
  const { site } = useSiteState();
  const getDefaults = () => {
    const faqs = site.faqs;
    return {
      faqs: faqs ?? [],
    };
  };

  const onSubmit = async (responseData: any) => {
    toast("FAQ's saved", { type: "success" });
  };

  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Update FAQs"
      endpoint={`sites/${site.id}`}
      method="put"
      className="min-h-[600px]"
      render={({ errors, control }) => (
        <>
          <div className="mb-6 mt-10">
            <Controller
              name="faqs"
              control={control}
              defaultValue=""
              render={({ field: { onChange, value } }): JSX.Element => (
                <div>
                  {value.map((faq: FAQType, index: number) => (
                    <div key={index}>
                      <FAQEditField
                        value={faq as FAQType}
                        onDelete={() => {
                          onChange(
                            value.filter((vv: any, vi: number) => vi !== index)
                          );
                        }}
                        onChange={(v: FAQType) => {
                          const nv = value;
                          nv[index] = v;
                          onChange(nv);
                        }}
                      />
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={() =>
                      onChange([...value, { question: "", answer: "" }])
                    }
                    className="text-white hover:text-green-600 mt-4"
                  >
                    <PlusIcon className="ml-3 w-5 h-5 block" size={20} />
                  </button>
                </div>
              )}
            />

            <FormFieldErrors errors={errors} field="play_link" />
          </div>
        </>
      )}
    />
  );
};

export default FAQsEditForm;
